"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = _interopRequireDefault(require("../../../../lib/core"));

var _abstract = _interopRequireDefault(require("../../../../lib/classes/abstract"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var NotificationPreferences = /*#__PURE__*/function (_AbstractClass) {
  _inherits(NotificationPreferences, _AbstractClass);

  var _super = _createSuper(NotificationPreferences);

  function NotificationPreferences() {
    var _temp, _this;

    _classCallCheck(this, NotificationPreferences);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _super.call.apply(_super, [this].concat(args)), _this.user_guid = null, _this.user = {
      firstname: null,
      lastname: null,
      email: null
    }, _this.company_guid = null, _this.notification_preferences = [], _temp));
  }

  _createClass(NotificationPreferences, [{
    key: "getNotificationPreference",
    value: // Methods
    function getNotificationPreference() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var notificationPreference = (this.notification_preferences || []).find(function (preference) {
        return preference.type === type;
      });

      if (!notificationPreference) {
        if (options.create !== true) {
          return null;
        }

        notificationPreference = {
          type: type
        };
        this.notification_preferences.push(JSON.parse(JSON.stringify(notificationPreference)));
      } // Use parse and stringify so we don't get a reference


      return JSON.parse(JSON.stringify(notificationPreference));
    }
  }, {
    key: "getNotificationPreferenceMethod",
    value: function getNotificationPreferenceMethod() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var notificationPreference = this.getNotificationPreference(type, options);
      var notificationPreferenceMethod = (notificationPreference.methods || []).find(function (preferenceMethod) {
        return preferenceMethod.name === method;
      });

      if (!notificationPreferenceMethod) {
        if (options.create === false) {
          return null;
        }

        notificationPreferenceMethod = {
          name: method,
          enabled: true
        }; // Add sync variable if this is a user notification preference document

        if (this.user_guid) {
          notificationPreferenceMethod.sync = true;
        }

        notificationPreference.methods.push(JSON.parse(JSON.stringify(notificationPreferenceMethod)));
      } // Use parse and stringify so we don't get a reference


      return JSON.parse(JSON.stringify(notificationPreferenceMethod));
    }
  }, {
    key: "isNotificationPreferenceEnabled",
    value: function isNotificationPreferenceEnabled() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var preference = this.getNotificationPreference(type);

      if (!preference) {
        return false;
      }

      return (preference.methods || []).some(function (method) {
        return method.enabled === true;
      });
    }
  }, {
    key: "setNotificationPreference",
    value: function setNotificationPreference() {
      var _this2 = this;

      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var methods = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var enabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (!type || !methods || typeof enabled !== 'boolean') {
        return null;
      } // eslint-disable-next-line no-param-reassign


      methods = typeof methods === 'string' ? [methods] : methods; // Find notification preference

      var notificationPreference = this.getNotificationPreference(type, {
        create: true
      }); // Set methods

      notificationPreference.methods = Array.isArray(notificationPreference.methods) ? notificationPreference.methods : []; // Add method if not found

      methods.forEach(function (method) {
        if (!notificationPreference.methods.find(function (preferenceMethod) {
          return preferenceMethod.name === method;
        })) {
          var methodObject = {
            name: method,
            enabled: true
          }; // Add sync variable if this is a user notification preference document

          if (_this2.user_guid) {
            methodObject.sync = true;
          }

          notificationPreference.methods.push(methodObject);
        } // Set method


        notificationPreference.methods.find(function (preferenceMethod) {
          return preferenceMethod.name === method;
        }).enabled = typeof enabled === 'boolean' ? enabled : true;
      }); // Add to notification preferences

      var preferenceIdx = this.notification_preferences.findIndex(function (preference) {
        return preference.type === type;
      });

      if (preferenceIdx === -1) {
        this.notification_preferences.push(notificationPreference);
      } else {
        this.notification_preferences[preferenceIdx] = notificationPreference;
      }

      return this.notification_preferences;
    }
  }, {
    key: "setSync",
    value: function setSync(type, methods) {
      var _this3 = this;

      var enabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (!this.user_guid || !methods || typeof enabled !== 'boolean') {
        return this.notification_preferences;
      } // eslint-disable-next-line no-param-reassign


      methods = typeof methods === 'string' ? [methods] : methods; // Find notification preference

      var notificationPreference = this.getNotificationPreference(type, {
        create: true
      }); // Set methods

      notificationPreference.methods = Array.isArray(notificationPreference.methods) ? notificationPreference.methods : []; // Add method if not found

      methods.forEach(function (method) {
        if (!notificationPreference.methods.find(function (preferenceMethod) {
          return preferenceMethod.name === method;
        })) {
          var methodObject = {
            name: method,
            enabled: true
          }; // Add sync variable if this is a user notification preference document

          if (_this3.user_guid) {
            methodObject.sync = true;
          }

          notificationPreference.methods.push(methodObject);
        } // Set method


        notificationPreference.methods.find(function (preferenceMethod) {
          return preferenceMethod.name === method;
        }).sync = typeof enabled === 'boolean' ? enabled : true;
      }); // Add to notification preferences

      var preferenceIdx = this.notification_preferences.findIndex(function (preference) {
        return preference.type === type;
      });

      if (preferenceIdx === -1) {
        this.notification_preferences.push(notificationPreference);
      } else {
        this.notification_preferences[preferenceIdx] = notificationPreference;
      }

      return this.notification_preferences;
    }
  }, {
    key: "isInSync",
    value: function isInSync() {
      if (!this.user_guid) {
        return false;
      }

      return (this.notification_preferences || []).every(function (preference) {
        return (preference.methods || []).every(function (method) {
          return method.sync === true;
        });
      });
    } // Static methods

  }], [{
    key: "getForCompany",
    value: function () {
      var _getForCompany = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(company_guid) {
        var options,
            document,
            _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                _context.next = 3;
                return _core["default"].ws.get("".concat(this.uri, "/companies/").concat(company_guid), _objectSpread({}, options));

              case 3:
                document = _context.sent;
                return _context.abrupt("return", new this().merge(document));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getForCompany(_x) {
        return _getForCompany.apply(this, arguments);
      }

      return getForCompany;
    }()
  }]);

  return NotificationPreferences;
}(_abstract["default"]);

exports["default"] = NotificationPreferences;
NotificationPreferences.uri = '/notifications/preferences';